import React from "react";
import { Box } from "@curves/ui-base";
import ActivityRecordCardPdfAttachment from "./ActivityRecordCardPdfAttachment";
import ActivityRecordCardActions from "./ActivityRecordCardActions";
import ActivityRecordCardContent from "./ActivityRecordCardContent";

const ActivityRecordCard = ({ status = "default", children }) => {
	return <Box className={`activity-record-card status-${status}`}>{children}</Box>;
};

ActivityRecordCard.PdfAttachment = ActivityRecordCardPdfAttachment;
ActivityRecordCard.Actions = ActivityRecordCardActions;
ActivityRecordCard.Content = ActivityRecordCardContent;

export default ActivityRecordCard;
